import React from "react";

const SecondaryAlert = ({ msg }) => (
    <div style={{ textAlign: "center" }} className="alert alert-secondary" role="alert">
        {msg}
    </div>
);

export default SecondaryAlert;